import { useTranslation } from "@ferrivia/i18n";
import { EmptyPane } from "../../components/EmptyPane";

export function TasksScreen() {
  const { t } = useTranslation("clinic");
  return <EmptyPane title={t("tasksScreen.title", "Tasks")} body={t("tasksScreen.empty", "Nothing here yet.")} />;
}
